import { createColumnHelper } from "@tanstack/react-table";

import { FiEye } from "react-icons/fi";

import { Link } from "react-router-dom";


const columnHelper =
    createColumnHelper();



export const attendanceColumns = () => [

    /*
    |--------------------------------------------------------------------------
    | EMPLOYEE
    |--------------------------------------------------------------------------
    */

    columnHelper.accessor(
        "employee.name",
        {
            header: "Employee",

            cell: (info) => (
                <span className="font-semibold">
                    {info.getValue() || "-"}
                </span>
            ),
        }
    ),


    /*
    |--------------------------------------------------------------------------
    | DATE
    |--------------------------------------------------------------------------
    */

    columnHelper.accessor(
        "workDate",
        {
            header: "Date",

            cell: (info) => {

                const value =
                    info.getValue();

                return value
                    ? new Date(
                        value
                    ).toLocaleDateString()
                    : "-";
            },
        }
    ),


    /*
    |--------------------------------------------------------------------------
    | CHECK IN
    |--------------------------------------------------------------------------
    */

    columnHelper.accessor(
        "checkInAt",
        {
            header: "Check In",

            cell: (info) => {

                const value =
                    info.getValue();

                return value
                    ? new Date(
                        value
                    ).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                    })
                    : "-";
            },
        }
    ),


    /*
    |--------------------------------------------------------------------------
    | CHECK OUT
    |--------------------------------------------------------------------------
    */

    columnHelper.accessor(
        "checkOutAt",
        {
            header: "Check Out",

            cell: (info) => {

                const value =
                    info.getValue();

                return value
                    ? new Date(
                        value
                    ).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                    })
                    : "-";
            },
        }
    ),


    /*
    |--------------------------------------------------------------------------
    | STATUS
    |--------------------------------------------------------------------------
    */

    columnHelper.accessor(
        "status",
        {
            header: "Status",

            cell: (info) => {

                const status =
                    info.getValue();

                const className =
                    status === "checked_out"
                        ? "bg-blue-100 text-blue-700"
                        : status === "checked_in"
                        ? "bg-green-100 text-green-700"
                        : "bg-gray-100 text-gray-700";


                return (
                    <span
                        className={`
                            inline-flex
                            items-center
                            justify-center
                            whitespace-nowrap
                            rounded-full
                            px-3
                            py-1
                            text-xs
                            font-semibold
                            ${className}
                        `}
                    >
                        {status
                            ? status.replace(
                                /_/g,
                                " "
                            )
                            : "-"
                        }
                    </span>
                );
            },
        }
    ),


    /*
    |--------------------------------------------------------------------------
    | WORKING
    |--------------------------------------------------------------------------
    */

    columnHelper.accessor(
        "totalMinutes",
        {
            header: "Working",

            cell: (info) => {

                const minutes =
                    info.getValue();

                if (
                    minutes === null ||
                    minutes === undefined
                ) {
                    return "-";
                }


                if (Number(minutes) === 0) {
                    return "0m";
                }


                const hours =
                    Math.floor(
                        Number(minutes) / 60
                    );


                const mins =
                    Number(minutes) % 60;


                return `${hours}h ${mins}m`;
            },
        }
    ),


    /*
    |--------------------------------------------------------------------------
    | ACTION
    |--------------------------------------------------------------------------
    */

    columnHelper.display({

        id: "actions",

        header: "Action",

        cell: ({ row }) => {

            const attendance =
                row.original;


            return (

                <div
                    className="
                        flex
                        min-w-[80px]
                        items-center
                        justify-center
                        gap-2
                        whitespace-nowrap
                    "
                >

                    <Link
                        to={`/admin/attendance/${attendance.id}`}
                        className="
                            inline-flex
                            h-9
                            w-9
                            min-h-9
                            min-w-9
                            shrink-0
                            items-center
                            justify-center
                            rounded-lg
                            bg-blue-600
                            p-0
                            text-white
                            transition
                            hover:bg-blue-700
                        "
                        title="View Attendance"
                    >

                        <FiEye
                            className="
                                h-4
                                w-4
                            "
                        />

                    </Link>

                </div>

            );
        },

    }),

];